export default __webpack_public_path__ + "static/media/motorbike_plant.8664eddb.png";